{
  "version": 1,
  "asset_id": "a397999b-3e3d-44fb-9bcf-18cbd73cc00d",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/a397999b-3e3d-44fb-9bcf-18cbd73cc00d/hiatal-type-2-sleeve-es-800.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/a397999b-3e3d-44fb-9bcf-18cbd73cc00d/hiatal-type-2-sleeve-es-800.jpg",
  "original_filename": "hiatal-type-2-sleeve-es-800.jpg",
  "size": 85643,
  "content_type": "image/jpeg",
  "created_at": "2026-09-26T22:45:54Z"
}
